import React from 'react';
import { Skeleton } from '@mui/material';

const MetricCardSkeleton: React.FC = () => {
  return (
    <div className="flex gap-4 items-start h-full w-full">
      <Skeleton
        variant="circular"
        animation="wave"
        sx={{
          flexShrink: 0,
          width: 70,
          height: 70,
          backgroundColor: '#EDF3F6'
        }}
        className="max-lg-xl:w-15! max-lg-xl:h-15!"
      />

      <div className="flex flex-col h-full gap-6 max-lg-xl:gap-4">
        <Skeleton
          variant="rounded"
          width={118}
          height={14}
          animation="wave"
          sx={{
            borderRadius: '50px',
            backgroundColor: '#EDF3F6'
          }}
        />

        <Skeleton
          variant="rounded"
          width={190}
          height={14}
          animation="wave"
          sx={{
            borderRadius: '50px',
            backgroundColor: '#EDF3F6'
          }}
        />

        <Skeleton
          variant="rounded"
          width={46}
          height={10}
          animation="wave"
          sx={{
            borderRadius: '50px',
            backgroundColor: '#EDF3F6'
          }}
        />
      </div>
    </div>
  );
};

export default MetricCardSkeleton;
